import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ButtonType } from '../button/button.component';
import { Ad } from '@core/models/ad.model';
import { MatDialog } from '@angular/material/dialog';
import { User } from '@core/models/auth.model';
import { FullscreenCarouselDialog } from 'src/app/routes/ads/ad/ad.component';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap/carousel/carousel.module';
import { ApiService } from '@shared/services/api.service';
import { LocaleService } from '@shared/services/locale.service';
import { SnackService } from '@shared/services/snack.service';
import { ViewportService } from '@shared/services/viewport.service';

@Component({
	selector: 'app-photo-layout',
	templateUrl: './photo-layout.component.html',
	styleUrls: ['./photo-layout.component.scss'],
})
export class PhotoLayoutComponent implements OnInit {
	constructor(
		private matDialog: MatDialog,
		private apiService: ApiService,
		public localeService: LocaleService,
		private snackService: SnackService,
		public viewport: ViewportService
	) {}

	@Input() ad: any;
	@Input() user: User;

	readonly buttonType = ButtonType;
	@ViewChild('carousel') carousel: NgbCarousel;

	onOpenGallery(event, ad: Ad): void {
		if (ad.images.length) {
			const fsRef = this.matDialog.open(FullscreenCarouselDialog, {
				maxWidth: '100vw',
				width: this.viewport.type !== 'mobile' ? '70%' : '100%',
				height: this.viewport.type !== 'mobile' ? '85%' : '100%',
				data: {
					images: this.ad['images'],
					slideID: 0,
					ad: ad,
				},
			});

			fsRef.afterClosed().subscribe(() => {
				setTimeout(() => {}, 500);
			});
		}
		event.stopPropagation();
	}

	onWatch(ad: Ad): void {
		if (this.user) {
			this.apiService
				.watch({
					lang: this.localeService.lang,
					userID: this.user.userID,
					adID: ad.id,
					watch: ad.watching === '1' ? '0' : '1',
				})
				.subscribe((response: any) => {
					if (response.status === '1') {
						this.ad = {
							...ad,
							watching: ad.watching === '1' ? '0' : '1',
						};

						this.snackService.open(response?.message);
					}
				});
		} else {
			this.snackService.open(this.localeService.translations['ads']['s1']);
		}
	}

	ngOnInit(): void {}
}
